<template>
  <div 
    class="grid1-1"
    :style="gridStyles"
  >
    <div></div>
    <div>
      <h4>Site</h4>
      <router-link to="/">
        <li class="list-item">
          <a class="nav-link" href="#">Home</a>
        </li>
      </router-link>
      <router-link to="/about">
        <li class="list-item">
          <a class="nav-link" href="#">About</a>
        </li>
      </router-link>
      <router-link to="/sites">
        <li class="list-item">
          <a class="nav-link" href="#">Sites</a>
        </li>
      </router-link>
    </div>
    <div>
      <h4>Legal</h4>
      <router-link to="/termsconditions">
        <li class="list-item">
          <a class="nav-link" href="#">Terms &amp; Conditions</a>
        </li>
      </router-link>
    </div>
    <div></div>
    <div class="copywrite">
      <p class="newfont">
        &copy; {{copywrite}}
      </p>
    </div>
    <slot></slot> 
  </div>
</template>

<script>
export default {
  name:'Grid1x1',
  props: {
    msg: String,
    copywrite:{
      type:String,
      default:""
    },
    gridStyles:{
      type:Object,
      default:function(){return {}}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid1-1 {
  box-sizing:border-box;
  display: grid;
  min-height:100px;
  grid-template-columns: repeat(4,1fr);
  grid-template-rows: 2fr;
}
.border {
  border: 1px dashed navy;
}
.newfont {
  font-family:'Varela Round';
}
.nav-link {
  text-decoration:none;
  font-size: 1.1em;
}
.list-item {
  list-style-type:"";
  margin-bottom:2em;
}
.copywrite {
  grid-row:2 / 3;
  grid-column:1 / 5;
  margin-top:25px;
}
</style>
